import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['details', 'tasw', 'revealAction'];

  reveal(ev) {
    this.detailsTarget.classList.remove('opacity-0');
    this.taswTarget.classList.add('hidden');
  }
}
